import { render } from "./AppInfo.vue?vue&type=template&id=46f2a320&scoped=true"
import script from "./AppInfo.vue?vue&type=script&lang=js"
export * from "./AppInfo.vue?vue&type=script&lang=js"

import "./AppInfo.vue?vue&type=style&index=0&id=46f2a320&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46f2a320"]])

export default __exports__